import { useContext, useEffect, useState } from "react";

import { auth } from "./firebase";
import Login from "./components/Auth/Login";
import {
  getIdTokenResult,
  onAuthStateChanged,
  ParsedToken,
} from "firebase/auth";

import { AppContext } from "./context/context";
import { payloadTypes } from "./context/reducer";
import SysAdminRoutes from "./Routes";
import AssetRoutes from "./components/modules/asset/Routes";
import QuotationRoutes from "./components/modules/asset/purchase/quotation/login/QuotationLoginRoutes";
import MobileRoutes from "./components/modules/asset/purchase/quotation/login/MobileRoutes";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import JunctionDataForResponsive from "./components/modules/asset/masters/subsidary/junctions/JunctionDataForResponsive";
import NotFound from "./NotFound";
const AssetManagement = () => {
  const [claims, setClaims] = useState<ParsedToken | null>(null);
  const { state, dispatch } = useContext(AppContext);
  const path = window.location.pathname;

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch({ type: payloadTypes.SET_USER, payload: { user } });
        getIdTokenResult(user).then((IdTokenResult) => {
          const { claims } = IdTokenResult;

          dispatch({
            type: payloadTypes.SET_CLAIMS,
            payload: { claims },
          });
          setClaims(claims);
        });
      }
    });
  }, [dispatch]);

  // tab closed clear the local storage and logout
  // useEffect(() => {
  //   const handleUnload = () => {
  //     // When tab is closing, sessionStorage will be cleared automatically.
  //     // So we delay clearing localStorage slightly.
  //     setTimeout(() => {
  //       if (!sessionStorage.length) {
  //         localStorage.removeItem("authToken");
  //       }
  //     }, 0);
  //   };
  //   window.addEventListener("unload", handleUnload);
  //   return () => {
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);

  const renderContent = () => {
    if (state.claims) {
      return state.claims.EDUATE ? <SysAdminRoutes /> : <AssetRoutes />;
    }

    if (path.includes("/vendor/")) return <QuotationRoutes />;
    if (path.includes("/astram")) return <MobileRoutes />;

    if (path.includes("/privacypolicy") || path.includes("/junctiondata"))
      return null;

    return (
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    );
  };

  return (
    <div className="h100">
      <div className="h100">
        <Router>
          <Routes>
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route
              path="/:junctionID/junctiondata"
              element={<JunctionDataForResponsive />}
            />
          </Routes>
        </Router>
        {renderContent()}
      </div>
    </div>
  );
};

export default AssetManagement;
